import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private httpClientService:HttpClientService) { }
  async getAllCategory(page,size,search,kindId){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Category,
      queryString:`&Page=${page}&Size=${size}&kindId=${kindId}`
    });
    return await firstValueFrom(observable);
  }

  async getAllCategories(page,size,search){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Category,
      action:"GetAllCategories",
      queryString:`&Page=${page}&Size=${size}&search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async createCategory(categoryName,kindId){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Category
    },{
      categoryName:categoryName,
      kindId:kindId
    });
    return await firstValueFrom(observable);
  }
  async updateCategory(id,categoryName,kindId){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.Category
    },{
      id:id,
      categoryName:categoryName,
      kindId:kindId
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();
  
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
